/**
 * Estatísticas de mercado exibidas na home (faixa abaixo do hero).
 *
 * Regra (docs/specs/standards/copy-and-i18n.md): todo número público tem
 * fonte primária linkada e ano. Sem fonte verificável, não entra.
 */
export interface MarketStat {
  value: string;
  label: string;
  /** Nome curto da fonte + ano, exibido como link. */
  source: string;
  href: string;
}

export const marketStats: MarketStat[] = [
  {
    value: "82%",
    label: "dos pequenos negócios vendem pelo WhatsApp",
    source: "Sebrae, Pulso dos Pequenos Negócios 2026",
    href: "https://agenciasebrae.com.br/dados/whatsapp-se-consolida-nas-vendas-on-line-enquanto-facebook-e-lojas-proprias-perdem-folego/",
  },
  {
    value: "7x",
    label: "mais chance de qualificar o lead quando a resposta sai na primeira hora",
    source: "Harvard Business Review, 2011",
    href: "https://hbr.org/2011/03/the-short-life-of-online-sales-leads",
  },
  {
    value: "47%",
    label: "das empresas brasileiras ainda não têm site próprio",
    source: "Cetic.br, TIC Empresas 2024",
    href: "https://cetic.br/media/docs/publicacoes/2/20250512121759/tic_empresas_2024_resumo_executivo.pdf",
  },
  {
    value: "60%",
    label: "das ocupações têm ao menos 30% das tarefas automatizáveis",
    source: "McKinsey Global Institute, 2017",
    href: "https://www.mckinsey.com/featured-insights/digital-disruption/harnessing-automation-for-a-future-that-works",
  },
];
